/**
 * PortfolioCarousel — Swiper coverflow carousel for homepage projects.
 *
 * Dynamically imports Swiper from CDN (ESM) to keep the main bundle lean.
 *
 * @module PortfolioCarousel
 */

export default class PortfolioCarousel {

  static DEFAULTS = {
    selector: '.wleb-portfolio-swiper',
    swiperCDN: 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs',
  };

  constructor() {
    this.el = document.querySelector(PortfolioCarousel.DEFAULTS.selector);
    if (!this.el) return;
    this.swiper = null;
    this._init();
  }

  async _init() {
    try {
      const { default: Swiper } = await import(PortfolioCarousel.DEFAULTS.swiperCDN);

      const slideCount = this.el.querySelectorAll('.swiper-slide').length;
      const canLoop = slideCount >= 3;

      this.swiper = new Swiper(this.el, {
        effect: canLoop ? 'coverflow' : 'slide',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        initialSlide: Math.floor(slideCount / 2),
        loop: canLoop,
        speed: 600,
        coverflowEffect: canLoop ? {
          rotate: 0,
          stretch: 60,
          depth: 250,
          modifier: 1,
          slideShadows: true,
        } : undefined,
        pagination: false,
        navigation: {
          nextEl: this.el.querySelector('.swiper-button-next'),
          prevEl: this.el.querySelector('.swiper-button-prev'),
        },
        breakpoints: canLoop ? {
          0: { slidesPerView: 1.2 },
          464: { slidesPerView: 1.5 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 'auto' },
        } : {
          0: { slidesPerView: 1 },
          768: { slidesPerView: Math.min(slideCount, 2) },
          1024: { slidesPerView: 'auto' },
        },
      });
    } catch (err) {
      // Swiper failed to load — grid stays visible as fallback.
      console.warn('[PortfolioCarousel] Swiper load failed:', err);
    }
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}
